<template>
  <div>
    <!-- 录入订单---手动录入 -->
    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
      <ul>
        <li><span>订单编号</span>：{{ this.orderCode }}</li>
        <li><span>公司</span>：{{ this.TC_NAME }}</li>
        <li><span>档口</span>：{{ this.DK_NAME }}</li>
        <li><span>客户习惯</span>：{{ this.commonHabits }}</li>
      </ul>
    </el-col>
    <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
      <ul>
        <li><span>总金额</span>：{{ this.orderFee }}</li>
        <li><span>项目点</span>：{{ this.PROJECT_NAME }}</li>
        <li><span>发货日期</span>：{{ this.send_day }}</li>
        <li><span>订单备注</span>：
          <div style="position: relative; z-index: 1; display: inline-block;">
            <el-input v-model="ORDER_LISTS_COMMENT" size="medium" placeholder="请输入订单备注" style="width: 100%;" @change="submitOrderComment" clearable>
            </el-input>
          </div>
        </li>
      </ul>
    </el-col>
    <el-row>
      <!-- 远程查询和添加数据-->
      <el-form :inline="true" class="demo-form-inline" style="margin: 0" :model="firstFormadd" ref="firstFormadd" @submit.native.prevent>
        <el-form-item label="产品名称：" prop="productName">
          <el-autocomplete size="medium" @keyup.enter.native="handelTab(1, $event)" ref="input1" class="inline-input"
            v-model="firstFormadd.productName" :fetch-suggestions="querySearchadd" placeholder="输入产品名称添加" :trigger-on-focus="false"
            @select="handleSelect" clearable :debounce="500" @clear="onAutocompleteClear">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="产品编码：" prop="productCode">
          <el-autocomplete size="medium" @keyup.enter.native="handelTab(2, $event)" ref="input2" class="inline-input"
            v-model="firstFormadd.productCode" :fetch-suggestions="querySearchCodeadd" placeholder="输入产品编码添加" :trigger-on-focus="false"
            @select="handleSelectCode" clearable>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="单位：">
          <el-input size="medium" style="width: 80px" v-model="addForm.TYPE_UNIT" disabled></el-input>
        </el-form-item>
        <el-form-item label="单价：">
          <el-input size="medium" @keyup.enter.native="handelTab(3, $event)" ref="input3" v-model="addForm.PRICE" :disabled="isisdisabled">
          </el-input>
        </el-form-item>
        <el-form-item label="订购数量：">
          <el-input size="medium" @keyup.enter.native="handelTab(4, $event)" ref="input4" v-model="addForm.count">
          </el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
          <el-input size="medium" @keyup.enter.native="handelTabSp" ref="input5" v-model="addForm.comment" maxlength="20" show-word-limit>
          </el-input>
        </el-form-item>
        <el-button style="display: inline-block" size="medium" @keydown.enter.native="handelTabKeyDown" @click="handelTabSpClick">
          确 定
        </el-button>
        <el-button style="display: inline-block" size="medium" @click="launchAllOrder" v-show="fun_dic[100000102]">
          发起到待送
        </el-button>
        <el-button style="display: inline-block" size="medium" @click="addNewSku()" v-show="fun_dic[100000101]">
          临时产品添加
        </el-button>
        <tooltip-button :disabled="Boolean(this.tableData.length)" buttonText="发起到出库" tipContent="请先添加产品" buttonClass="operate-btn"
          @click="launchToDelivery" v-if="fun_dic[100000104]">
        </tooltip-button>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table border :row-class-name="getTableRowClass" :data="tableData" style="margin-top: 20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="SHORT_NAME"></el-table-column>
          <el-table-column label="品牌" prop="BRAND"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="所属分类" prop="CATALOG_NAME"></el-table-column>
          <el-table-column label="单价" prop="REAL_PRICE">
            <template slot-scope="scope">
              <el-input v-model="scope.row.REAL_PRICE" :disabled="isisdisabled" @change="setActualNumber(scope.row)" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="不含税单价" prop="BEFORE_TAX_PRICE">
            <template slot-scope="scope">
              <el-input v-model="scope.row.BEFORE_TAX_PRICE" disabled>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="订购数量" prop="PRODUCT_COUNT">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRODUCT_COUNT" @change="setActualNumber(scope.row)" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="总金额" prop="TOTAL_FEE"></el-table-column>
          <el-table-column label="备注" prop="PRODUCT_COMMENT">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRODUCT_COMMENT" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="85">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="editProduct(scope.row)">修改</el-button>
              <el-button size="small" type="text" @click="showReplaceProductDialog(scope.row)" v-show="fun_dic[100000103]">
                替换产品
              </el-button>
              <el-button size="small" type="text" @click="deleteProduct(scope.row)" style="color: #f56c6c">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <tooltip-button :disabled="Boolean(tableData.length)" tipContent="订单为空，不能确认修改" buttonText="确认修改" buttonType="primary" @click="batchEdit"
          style="margin: 20px;">
        </tooltip-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <!-- 修改按钮模态框 -->
        <el-dialog title="修改产品" center :visible.sync="editFormVisible" width="600px">
          <el-form size="small" :model="editForm" ref="editForm">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ this.editForm.PRODUCT_NAME }}</span>
            </el-form-item>
            <el-form-item label="单位：" :label-width="formLabelWidth">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
              <span>{{ this.editForm.TYPE_UNIT }}</span>
            </el-form-item>
            <el-form-item label="单价：" :label-width="formLabelWidth">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
              <el-input v-model="editForm.REAL_PRICE" :disabled="isisdisabled" @change="RealPrice" oninput="value=value.replace(/[^0-9.]/g,'')">
              </el-input>
            </el-form-item>
            <el-form-item label="订购数量：" :label-width="formLabelWidth">
              <el-input v-model="editForm.PRODUCT_COUNT" @change="ProductCount"></el-input>
            </el-form-item>
            <el-form-item label="备注：" :label-width="formLabelWidth">
              <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
              <el-input v-model="editForm.PRODUCT_COMMENT" maxlength="20" show-word-limit></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitEdit">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 替换产品模态框 -->
        <el-dialog title="替换产品" center :visible.sync="replaceProductDialogVisible" width="600px">
          <el-form size="small" :model="replaceProductForm" ref="replaceProductForm">
            <el-form-item label="产品名称：">
              <el-autocomplete size="medium" class="inline-input" ref="replaceProductName" v-model="replaceProductForm.productName"
                :fetch-suggestions="querySearchReplace" placeholder="输入产品名称添加" @select="handleReplaceFormSelect" clearable>
              </el-autocomplete>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="replaceProductDialogVisible = false">取 消</el-button>
            <el-button size="small" @click="submitReplaceProduct()">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 临时产品添加 -->
        <el-dialog title="临时产品添加" center :visible.sync="addSKUFormVisible" width="450px">
          <el-form :model="addSKUForm" ref="addSKUForm">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <el-input v-model="addSKUForm.NAME"></el-input>
            </el-form-item>
            <el-form-item label="单位：" :label-width="formLabelWidth">
              <el-select v-model="addSKUForm.TYPE_UNIT" filterable style="width: 280px" placeholder="请选择" clearable>
                <el-option v-for="item in TYPE_UNIT_LIST" :key="item.KD_CODE + '/' + item.UNIT_ID" :label="item.TYPE_UNIT"
                  :value="item.KD_CODE + '/' + item.UNIT_ID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌：" :label-width="formLabelWidth">
              <el-input v-model="addSKUForm.BRAND"></el-input>
            </el-form-item>
            <el-form-item label="规格：" :label-width="formLabelWidth">
              <el-input v-model="addSKUForm.SPECIFICATION"></el-input>
            </el-form-item>
            <el-form-item label="一级大类：" :label-width="formLabelWidth">
              <el-select filterable v-model="addSKUForm.FIRST_TYPE" style="width: 100%" @change="getSecond()">
                <el-option v-for="item in firstLists" :key="item.INNER_CODE" :value="item.INNER_CODE" :label="item.NAME">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级大类：" :label-width="formLabelWidth">
              <el-select filterable v-model="addSKUForm.SECOND_TYPE" style="width: 100%">
                <el-option v-for="item in secondLists" :key="item.INNER_CODE" :value="item.INNER_CODE" :label="item.NAME">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出库方式：" :label-width="formLabelWidth">
              <el-select filterable v-model="addSKUForm.OW_TYPE" style="width: 100%">
                <el-option v-for="item in wayOut" :key="item.ID" :value="item.ID" :label="item.NAME"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="自有分类：" :label-width="formLabelWidth">
              <el-select v-model="addSKUForm.CATALOG_ID" style="width:100%">
                <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button @click="submitAddSKU">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>

    <el-dialog title="发起到出库" center :visible.sync="deliveryDialog" width="90%" :close-on-click-modal="false">
      <el-table ref="table" v-loading="loading" :data="listData" :span-method="objectSpanMethod" class="tableArea" style="width: 100%" border
        :cell-style="setOutBackgroundColor">
        <el-table-column prop="ID" label="序号" width="50">
          <template slot-scope="scope">
            <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
              {{ scope.row.ID }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="NAME" label="名称">
          <template slot-scope="scope">
            <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
              {{ scope.row.NAME }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位">
          <template slot-scope="scope">
            <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
              {{ scope.row.TYPE_UNIT }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="NEED_COUNT" label="所需总数">
          <template slot-scope="scope">
            <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
              {{ scope.row.NEED_COUNT }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="PRODUCT_COMMENT" label="备注">
          <template slot-scope="scope">
            <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
              {{ scope.row.PRODUCT_COMMENT }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="可出库产品">
          <el-table-column prop="WAREHOUSE_PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="NEW_TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="单价"></el-table-column>
          <el-table-column prop="BATCH" label="批次"></el-table-column>
          <el-table-column prop="PRODUCTION_DATE" label="生产日期"></el-table-column>
          <el-table-column label="保质期">
            <template slot-scope="scope">
              <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="INW_COUNT" label="库存数量"></el-table-column>
          <el-table-column prop="LOCATION_CODE" label="库位" v-if="WAREHOUSE_MODE == 2"></el-table-column>
          <el-table-column prop="LACK_COUNT" label="出库数量" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.LACK_COUNT" :placeholder="scope.row.PLACE_LACK_COUNT" @blur="onDeliveryBlur(scope.row)">
              </el-input>
            </template>
          </el-table-column>
        </el-table-column>
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="modify(scope.row)">添加出库产品</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="deliveryDialog = false">取 消</el-button>
        <el-button size="small" @click="submitLaunchToDelivery">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 添加出库产品 -->
    <el-dialog title="添加出库产品" :visible.sync="addDeliveryProductVisible" center width="1000px" @close="closeDialog" :close-on-click-modal="false">
      <el-row style="margin-top: 20px">
        <el-col>
          <el-form size="small" :inline="true" class="demo-form-inline" style="padding: 0; margin: 0">
            <el-form-item label="产品名称：">
              <el-input v-model="searchForm.name" @keyup.enter.native="handleSearch()" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="handleSearch" :loading="loading">筛选</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <span>需出库产品：{{ addlist_row.NAME }}</span>
          <span>所需总数：{{ addlist_row.NEED_COUNT }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="addDeliveryProductData" stripe border style="width: 100%;margin-top: 20px">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="80"></el-table-column>
            <el-table-column prop="BATCH" label="批次" min-width="80"></el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="库存" min-width="80"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位" min-width="80"></el-table-column>
            <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="80"></el-table-column>
            <el-table-column label="数量" min-width="70">
              <template slot-scope="scope">
                <el-input size="small" v-model="scope.row.NEED_COUNT" placeholder="请输入" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="addProduct(ID, scope.row)">添加</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div class="pagination_box" style="text-align: left; margin-top: 20px">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">完成</el-button>
      </div>
    </el-dialog>
    <el-dialog title="缺货采购" center :visible.sync="outOfStockDialog" width="90%" :close-on-click-modal="false">

      <el-form :inline="true" class="demo-form-inline" :model="outOfStockForm">
        <el-form-item label="送货日期：">
          <el-date-picker v-model="outOfStockForm.SEND_DATE" type="date" placeholder="请选择送货日期" :clearable="false">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <el-table ref="table" v-loading="loading" :data="outOfStockList" :span-method="objectSpanMethod" class="tableArea" style="width: 100%" border
        :cell-style="setOutBackgroundColor">
        <el-table-column prop="ID" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="PURCHASE_COUNT" label="采购数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.PURCHASE_COUNT" @blur="onPurchaseCountBlur(scope.row)" clearable>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="PRICE" label="单价">
          <template slot-scope="scope">
            <el-input v-model="scope.row.PRICE" @blur="onPurchasePriceBlur(scope.row)" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="SUPPLIER_ID" label="供应商">
          <template slot-scope="scope">
            <el-select filterable v-model="scope.row.SUPPLIER_ID">
              <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeOutOfStockDialog">取 消</el-button>
        <el-button size="small" @click="submitPurchase">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  updateOrderFun, orderDetailFun, deleteOrderDetailFun, chooseEntryFun, bulkLaunch,
} from 'api/sellOrder';
import { unitManageFun } from 'api/systemSetting';
import { getActionFun } from 'api/login';
import {
  getClassFun, getLKDFirstKindFun, getLKDSecondKindFun,
} from '@/assets/api/skuManage';
import http from '@/assets/common/http';
import util from '../../assets/common/util';
import validation from '@/assets/common/validation';
import { queryWarehouseFun, setOutFontColor, stockOutDetailFun } from '@/assets/api/warehouseManager';
import { haveGYSFun } from '@/assets/api/shopOrderManage';
import { showFullScreenLoading, tryHideFullScreenLoading } from '@/assets/plugin/loading/loading';

export default {
  data() {
    return {
      statusFlag: 0,
      checkData: [],
      fromName: ['entryOrderList'],
      toName: [],
      PAGE_ID: '1000001', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        100000101: 0, 100000102: 0, 100000103: 0, 100000104: 0,
      },
      loading: false,
      addLoad: false,
      orderCode: sessionStorage.getItem('orderCode'),
      orderId: sessionStorage.getItem('orderId'),
      tableData: [],
      editFormVisible: false,
      editForm: {},
      formLabelWidth: '120px',
      firstForm: {},
      addFormVisible: false,
      addForm: {},
      GYSForm: {},
      PRODUCT_NAME: '',
      TYPE_UNIT: '',
      companys: [],
      SUPPLIER_ID: '',
      isdisabled: false,
      orderFee: 0,
      firstFormadd: {
        productName: '',
        productCode: '',
      },
      TC_NAME: sessionStorage.getItem('TC_NAME'),
      PROJECT_NAME: sessionStorage.getItem('PROJECT_NAME'),
      DK_NAME: sessionStorage.getItem('DK_NAME'),
      send_day: sessionStorage.getItem('send_day'),
      CAN_MODIFY_PRICE: sessionStorage.getItem('CAN_MODIFY_PRICE'),
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      isisdisabled: false,
      canModify: '',
      canEveryoneModify: '',
      commonHabits: '',
      TYPE_UNIT_LIST: [],
      ADD_TYPE_UNIT: '',
      addSKUFormVisible: false,
      addSKUForm: {},
      firstLists: [],
      secondLists: [],
      wayOut: [
        {
          ID: 1,
          NAME: 'MTO',
        }, {
          ID: 2,
          NAME: 'MTS',
        }, {
          ID: 3,
          NAME: 'DS',
        },
      ],
      catalogList: [],
      BE_WAREHOUSE: '',
      ORDER_LISTS_COMMENT: '',
      enterFlag: 0,
      replaceProductDialogVisible: false,
      replaceProductForm: {
        productName: '',
      },
      deliveryDialog: false,
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      listData: [],
      spanArr: [],
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
      ID: '',

      addlist_row: {},
      searchForm: {},
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      addDeliveryProductData: [],
      addDeliveryProductVisible: false,
      outOfStockList: [],
      outOfStockDialog: false,
      outOfStockForm: {
        SEND_DATE: sessionStorage.getItem('send_day'),
      },
    };
  },
  methods: {
    showReplaceProductDialog(row) {
      this.replaceProductForm.ORDER_DETAIL_ID = row.ORDER_DETAIL_ID;
      this.replaceProductDialogVisible = true;
      this.replaceProductForm.productName = row.PRODUCT_CODE ? '' : row.SHORT_NAME;
      if (!row.PRODUCT_CODE) {
        this.$nextTick(() => {
          this.$refs.replaceProductName.focus();
        });
      }
    },
    handleReplaceFormSelect(item) {
      this.replaceProductForm.PRODUCT_CODE = item.PRODUCT_CODE;
    },
    submitReplaceProduct() {
      if (!this.replaceProductForm.PRODUCT_CODE) {
        this.$message.show({ text: '请选择您要更改的产品！', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 51,
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        ORDER_DETAIL_ID: this.replaceProductForm.ORDER_DETAIL_ID,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE: this.replaceProductForm.PRODUCT_CODE,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.replaceProductDialogVisible = false;
        this.replaceProductForm = { productName: '' };
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // input框回车自动聚焦下一个input框
    handelTab(i, e) {
      if (this.enterFlag == 1) {
        this.enterFlag = 0;
        return false;
      }
      const that = this;
      if (that.$refs[`input${i}`]) {
        that.$nextTick(() => {
          e.target.blur();
          const index = i + 1;
          that.$refs[`input${index}`].focus();
        });
      }
    },
    queryUnit() {
      const params = {
        SERVICE_ID: '60001',
        OTYPE: 1,
        PAGE_INDEX: 0,
        PAGE_SIZE: 100000,
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.TYPE_UNIT_LIST = result[0].UNIT_DATA;
          this.totalNum = result[0].TOTAL_COUNT;
        } else {
          this.TYPE_UNIT_LIST = [];
          this.totalNum = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    Price(e) {
      this.addForm.PRICE = e;
    },
    Count(e) {
      this.addForm.count = e;
    },
    RealPrice(e) {
      this.editForm.REAL_PRICE = e;
    },
    ProductCount(e) {
      this.editForm.PRODUCT_COUNT = e;
    },
    // 提交手动录入数据以及重新聚焦第一个input框
    handelTabSp(e) {
      this.submitAdd();
      e.target.blur();
      this.$refs.input1.focus();
      this.queryTypeUnit();
    },
    handelTabSpClick(e) {
      this.submitAdd();
      this.$refs.input1.focus();
      this.queryTypeUnit();
    },
    handelTabKeyDown(e) {
      this.enterFlag = 1;
      e.target.blur();
      this.handelTabSpClick();
    },
    querySearchadd(queryString, callback) {
      if (!validation.产品编码验证(this.firstFormadd.productCode)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        callback([]);
        return false;
      }
      this.$_getSearchRushOrderList1(queryString).then((res) => {
        const tmpArr = res.map((item) => ({
          CATALOG_NAME: item.CATALOG_NAME,
          NAME: item.NAME,
          PRICE: item.PRICE,
          PRODUCT_CODE: item.PRODUCT_CODE.toString(),
          TYPE_UNIT: item.TYPE_UNIT,
          PRODUCT_COUNT: item.PRODUCT_COUNT,
        }));
        const results = tmpArr.map((item) => {
          item.value = `${item.NAME}(${item.TYPE_UNIT}) 类别:${item.CATALOG_NAME} '可用量': ${item.PRODUCT_COUNT}`;
          return item;
        });
        callback(results);
      });
    },
    querySearchReplace(queryString, callback) {
      this.$_getSearchRushOrderListReplace(queryString).then((res) => {
        const tmpArr = res.map((item) => ({
          CATALOG_NAME: item.CATALOG_NAME,
          NAME: item.NAME,
          PRICE: item.PRICE,
          PRODUCT_CODE: item.PRODUCT_CODE,
          TYPE_UNIT: item.TYPE_UNIT,
        }));
        const results = tmpArr.map((item) => {
          item.value = `${item.NAME}(${item.TYPE_UNIT})`;
          return item;
        });
        callback(results);
      });
    },
    // 挑选
    handleSelect(item) {
      this.addForm = item;
      this.firstFormadd.productCode = item.PRODUCT_CODE;
    },
    querySearchCodeadd(queryString, callback) {
      if (!validation.产品编码验证(this.firstFormadd.productCode)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        return false;
      }
      this.$_getSearchRushOrderList1(queryString).then((res) => {
        const tmpArr = res.map((item) => ({
          CATALOG_NAME: item.CATALOG_NAME,
          NAME: item.NAME,
          PRICE: item.PRICE,
          PRODUCT_CODE: item.PRODUCT_CODE,
          TYPE_UNIT: item.TYPE_UNIT,
        }));
        const results = tmpArr.map((item) => {
          item.value = item.PRODUCT_CODE;
          return item;
        });
        callback(results);
      });
    },
    $_getSearchRushOrderListReplace() {
      const data = {
        SERVICE_ID: '10013',
        OTYPE: 22,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: Number(sessionStorage.getItem('projectId')),
        SEND_DAY: sessionStorage.getItem('send_day'),
        PRICE_MODE: this.userPriceType,
      };
      if (this.replaceProductForm.productName) {
        data.PRODUCT_NAME = this.replaceProductForm.productName;
      }
      return new Promise((resolve, reject) => {
        http.post(data).then((res) => {
          resolve(res[0].list);
        });
      });
    },
    handleSelectCode(item) {
      this.addForm = item;
      this.firstFormadd.productName = `${item.NAME}(${item.TYPE_UNIT})`;
    },
    isquery() {
      if (this.SUPPLIER_ID === '') {
        this.$message.show({ text: '请选择供应商', type: 'warning' });
        this.isdisabled = true;
      }
    },
    // 搜索接口调用
    $_getSearchRushOrderList(NAME, SUPPLIER_ID) {
      const data = {
        PRODUCT_NAME: this.firstForm.productName,
        PROJECT_ID: Number(sessionStorage.getItem('projectId')),
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        SUPPLIER_ID,
      };
      return new Promise((resolve, reject) => {
        chooseEntryFun(data).then((res) => {
          resolve(res[0].list);
        }).catch((err) => {
          this.$message.show({ text: '请选择供应商', type: 'warning' });
        });
      });
    },
    $_getSearchRushOrderList1() {
      const data = {
        SERVICE_ID: '10013',
        OTYPE: 22,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: Number(sessionStorage.getItem('projectId')),
        SEND_DAY: sessionStorage.getItem('send_day'),
        PRICE_MODE: this.userPriceType,
      };
      if (this.firstFormadd.productName) {
        data.PRODUCT_NAME = this.firstFormadd.productName;
      }
      if (this.firstFormadd.productCode) {
        data.PRODUCT_CODE = this.firstFormadd.productCode;
      }
      return new Promise((resolve, reject) => {
        http.post(data).then((res) => {
          resolve(res[0].list);
        }).catch(() => { resolve([]); });
      });
    },
    addFormClose() {
      this.addFormVisible = false;
    },
    // ---------------------------添加·产品·确认·按钮
    submitAdd() {
      this.addOrderProduct();
    },
    addOrderProduct() {
      if (!this.firstFormadd.productName) {
        this.$message.show({ text: '请输入产品名称', type: 'warning' });
        return false;
      }
      if (this.BE_WAREHOUSE == 1) {
        if (!validation.价格正数验证(this.addForm.PRICE)) {
          this.$message.show({ text: '请输入正数单价', type: 'warning' });
          return false;
        }
      } else {
        if (!validation.价格正数0验证(this.addForm.PRICE)) {
          this.$message.show({ text: '请输入正数单价', type: 'warning' });
          return false;
        }
      }
      if (util.JudgmentUnit(this.addForm.TYPE_UNIT)) { // 如果不是
        if (!validation.数量正负数验证(this.addForm.count)) {
          this.$message.show({ text: '请输入正确的订购数量', type: 'warning' });
          return false;
        }
      } else {
        if (!validation.数量整数正负数验证(this.addForm.count)) {
          this.$message.show({ text: '单位不是KG或斤的，只能输入整数', type: 'warning' });
          return false;
        }
      }
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 2,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: sessionStorage.getItem('orderId'),
        PRODUCT_COUNT: this.addForm.count,
        PRODUCT_COMMENT: this.addForm.comment || '',
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
      };
      if (this.addForm.PRICE) {
        params.PRICE = this.addForm.PRICE;
      }
      this.loading = true;
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.firstFormadd.productName = '';
        this.firstFormadd.productCode = '';
        this.addForm = {};
        this.loading = false;
        this.addFormVisible = false;
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
      // this.queryTable();
    },
    // --------------------------------页面加载完成请求的订单详情数据
    queryTable() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
      };
      orderDetailFun(params).then((result) => {
        if (result[0].DETAIL.length !== 0) {
          this.tableData = result[0].DETAIL;
          this.orderFee = result[0].TITLE[0].TOTAL_SUPPLIER_FEE;
          this.checkData = result[0].OR[0] ? result[0].OR[0].DATA : [];
          this.statusFlag = result[0].OR[0] ? result[0].OR[0].RN : 0;
        } else {
          this.tableData = [];
          this.orderFee = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.ORDER_LISTS_COMMENT = result[0].TITLE[0].ORDER_LISTS_COMMENT;
        this.BE_WAREHOUSE = result[0].TITLE[0].BE_WAREHOUSE;
        this.getCommonHabits(result[0].TITLE[0].TC_ID, result[0].TITLE[0].SUPPLIER_ID);
        this.canModify = result[0].CAN_MODIFY;
        this.queryTypeUnit();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------删除操作
    deleteProduct(row) {
      this.queryTypeUnit();
      this.$confirm('确定从订单中删除此商品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const delParams = {
          ORDER_DETAIL_ID: row.ORDER_DETAIL_ID,
        };
        deleteOrderDetailFun(delParams).then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消删除' });
      });
    },
    editProduct(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.queryTypeUnit();
    },
    // ------------------------------修改订单详情
    updateOrderDate() {
      if (this.BE_WAREHOUSE == 1) {
        if (!validation.价格正数验证(this.editForm.REAL_PRICE)) {
          this.$message.show({ text: '请输入正数单价', type: 'warning' });
          return false;
        }
      } else {
        if (!validation.价格正数0验证(this.editForm.REAL_PRICE)) {
          this.$message.show({ text: '请输入正数单价', type: 'warning' });
          return false;
        }
      }
      if (!util.JudgmentUnit(this.editForm.TYPE_UNIT)) { // 如果不是
        const beInter = (this.editForm.PRODUCT_COUNT % 1 === 0);
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
          return false;
        }
      }
      const updateParams = {
        PRODUCT_CODE: Number(this.editForm.PRODUCT_CODE),
        NEW_COUNT: Number(this.editForm.PRODUCT_COUNT),
        ORDER_DETAIL_ID: Number(this.editForm.ORDER_DETAIL_ID),
        PRICE: Number(this.editForm.REAL_PRICE),
      };
      if (this.editForm.PRODUCT_COMMENT !== '') {
        updateParams.PRODUCT_COMMENT = this.editForm.PRODUCT_COMMENT;
      }
      this.loading = true;
      updateOrderFun(updateParams).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editFormVisible = false;
        this.loading = false;
        this.queryTable();
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
      // }
    },
    submitEdit() {
      this.updateOrderDate();
    },
    close() {
      this.editFormVisible = false;
      this.addSKUFormVisible = false;
      this.queryTable();
    },
    // 发起到待送
    launchAllOrder() {
      if (this.tableData.length == 0) {
        this.$message.show({ text: '空订单不可发起到待送', type: 'warning' });
        return false;
      }
      const params = {
        ORDER_IDS: [Number(this.orderId)],
      };
      bulkLaunch(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        setTimeout(() => {
          this.$router.push({ name: 'entryOrderList' });
        }, 100);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryTypeUnit() {
      unitManageFun().then((result) => {
        this.canEveryoneModify = result[0].CAN_EVERYONE_MODIFY;
        if (this.canModify == 1 && this.canEveryoneModify == 0) {
          this.$message.show({ text: '注意：非本人创建订单', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getCommonHabits(TC_ID, GYS_ID) {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 24,
        TC_ID,
        GYS_ID,
      };
      http.post(params).then((res) => {
        this.commonHabits = res[0] ? res[0].COMMENT : '';
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 临时产品添加
    addNewSku() {
      this.queryFirstCatalog();
      this.queryCatalog();
      this.addSKUFormVisible = true;
    },
    // 获取LKD系统一级二级大类
    queryFirstCatalog() {
      const param = {
        PAGEINDEX: 0,
        PAGESIZE: 1000,
      };
      getLKDFirstKindFun(param)
        .then((result) => {
          this.firstLists = result.length > 0 ? result[0].OP_ROLE : [];
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 获取LKD系统二级大类
    getSecond() {
      this.querySecondCatalog();
    },
    querySecondCatalog() {
      const param = {
        PAGEINDEX: 0,
        PAGESIZE: 1000,
        FIRST_CATALOG_CODE: this.addSKUForm.FIRST_TYPE,
      };
      getLKDSecondKindFun(param).then((result) => {
        this.secondLists = result.length > 0 ? result[0].OP_ROLE : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取自有分类
    queryCatalog() {
      const params = {};
      getClassFun(params).then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 添加未审核SKU
    submitAddSKU() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const strlist = this.addSKUForm.TYPE_UNIT.split('/');
          this.TYPE_UNIT_LIST.map((item) => {
            if (item.UNIT_ID == strlist[1]) {
              this.ADD_TYPE_UNIT = item.TYPE_UNIT;
            }
          });
          const params = {
            SERVICE_ID: '10050',
            OTYPE: 19,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SHORT_NAME: this.addSKUForm.NAME,
            CATALOG_ID: this.addSKUForm.CATALOG_ID,
            OW_TYPE: this.addSKUForm.OW_TYPE,
            // TYPE_UNIT: this.addSKUForm.TYPE_UNIT,
            TYPE_UNIT: this.ADD_TYPE_UNIT,
            UNIT_ID: strlist[1],
            KD_CODE: strlist[0],
            SECOND_CATALOG_CODE: this.addSKUForm.SECOND_TYPE,
          };
          if (this.addSKUForm.SPECIFICATION) {
            params.SPECIFICATION = this.addSKUForm.SPECIFICATION;
          } else {
            params.SPECIFICATION = '';
          }
          if (this.addSKUForm.BRAND) {
            params.BRAND = this.addSKUForm.BRAND;
          } else {
            params.BRAND = '';
          }
          if (!this.addSKUForm.NAME || !this.addSKUForm.TYPE_UNIT || !this.addSKUForm.FIRST_TYPE || !this.addSKUForm.SECOND_TYPE || !this.addSKUForm.OW_TYPE || !this.addSKUForm.CATALOG_ID) {
            this.$message.show({ text: '请输入产品名称、单位、一级大类、二级大类、出库方式和自有分类', type: 'warning' });
            return false;
          }
          http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addSKUFormVisible = false;
            this.addSKUForm = {};
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // 改变订购数量触发
    setActualNumber(row) {
      if (!validation.价格正数0验证(row.REAL_PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        row.REAL_PRICE = '';
        return false;
      }
      if (row.REAL_PRICE == 0 && this.DK_NAME == '仓库') {
        this.$message.show({ text: '仓库订单单价不能为0', type: 'warning' });
        row.REAL_PRICE = '';
        return false;
      }

      if (util.JudgmentUnit(row.TYPE_UNIT)) {
        if (!validation.数量正负数验证(row.PRODUCT_COUNT)) {
          this.$message.show({ text: '请输入正确的订购数量', type: 'warning' });
          row.PRODUCT_COUNT = '';
          return false;
        }
      } else {
        if (!validation.数量整数正负数验证(row.PRODUCT_COUNT)) {
          this.$message.show({ text: '单位不是KG或斤的，只能输入整数', type: 'warning' });
          row.PRODUCT_COUNT = '';
          return false;
        }
      }
    },
    // 批量修改
    batchEdit() {
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 39,
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
      };
      let flag = 1;
      this.tableData.forEach((item) => {
        if (item.REAL_PRICE == '' || item.PRODUCT_COUNT == '') {
          flag = 2;
        }
      });
      if (flag == 2) {
        this.$message.show({ text: '请输入单价、订购数量', type: 'warning' });
        return false;
      }
      params.ORDER_DETAIL_LIST = this.tableData;

      http.post(params).then((res) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    submitOrderComment() {
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 44,
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        ORDER_LISTS_COMMENT: this.ORDER_LISTS_COMMENT || '',
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },


    launchToDelivery() {
      this.queryData();
      this.deliveryDialog = true;
    },
    setOutBackgroundColor({
      row, column, rowIndex, columnIndex,
    }) {
      const indexArry = this.WAREHOUSE_MODE ? [5, 6, 7, 8, 9, 10, 11, 12] : [5, 6, 7, 8, 9, 10, 11];
      if (indexArry.includes(columnIndex)) {
        if (row.LACK_COUNT && row.ORDER_REAL_PRICE < row.PRODUCT_PRICE) {
          return { backgroundColor: '#FDE2E2' };
        }
      }
      return {};
    },
    // ---------------------------------表格合并行
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 2) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 3) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 4) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (this.WAREHOUSE_MODE == 2 ? columnIndex === 14 : columnIndex === 13) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    // 页面加载时请求的数据
    queryData() {
      const params = {
        ORDER_ID: Number(this.orderId),
      };
      stockOutDetailFun(params).then((result) => {
        this.listData = result.map((item) => {
          // item.WAREHOUSE_PRODUCT_NAME = item.NAME;
          item.NEW_TYPE_UNIT = item.TYPE_UNIT;
          return Object.assign(item, { PLACE_LACK_COUNT: item.LACK_COUNT });
        });
        this.rowspan();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    rowspan() {
      this.listData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else if (this.listData[index].ID === this.listData[index - 1].ID) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    $_setFontColor(number) {
      return setOutFontColor(Number(number));
    },
    // 添加出库产品按钮
    modify(row) {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(row.LACK_COUNT)) {
        this.$message.show({ text: '请输入正数出库数量', type: 'warning' });
        return false;
      }
      this.addlist_row = row;
      this.ID = row.ID;
      this.addDeliveryProductVisible = true;
    },
    // 关闭模态框
    closeDialog() {
      this.addDeliveryProductVisible = false;
      this.editFormVisible = false;
      this.searchForm = {};
      this.addDeliveryProductData = [];
      this.totalCount = 0;
    },
    // ----------------分页
    handleCurrentChange() {
      this.handleSearch();
    },
    handleSearch() {
      const params = {
        PRODUCT_NAME: this.searchForm.name,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: 0,
        FLAG: 0,
      };
      this.loading = true;
      queryWarehouseFun(params).then((result) => {
        this.totalCount = result[0].TOTAL_COUNT;
        this.addDeliveryProductData = result[0].OP_ROLE.map((item, index) => Object.assign(item, { NEED_COUNT: '' }));
        if (result[0].TOTAL_WORTH !== '') {
          this.total_price = result[0].TOTAL_WORTH;
        } else {
          this.total_price = 0;
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 增加一条新的数据
    addProduct(id, row) {
      if (!row.NEED_COUNT || row.NEED_COUNT == '') {
        this.$message.show({ text: '请输入出库数量', type: 'warning' });
        return false;
      }
      // 正则：正数
      const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      // 正则：正整数(后面可以跟.0000)
      const reg2 = /^\d+(\.0+)?$/;
      if (util.JudgmentUnit(row.TYPE_UNIT)) {
        if (!reg1.test(row.NEED_COUNT)) {
          this.$message.show({ text: '请输入正数出库数量', type: 'warning' });
          return false;
        }
      } else if (!reg2.test(row.NEED_COUNT)) {
        this.$message.show({ text: '请输入正整数出库数量', type: 'warning' });
        return false;
      }
      if (row.NEED_COUNT) {
        let tag = true;
        const data = [
          {
            ADDED: 0,
            BATCH: row.BATCH,
            ENOUGH_FLAG: 1,
            // EXPIRATION_DAY: Number(row.EXPIRATION_DAY),
            QGP: Number(row.QGP),
            QGP_TIME_TYPE: Number(row.QGP_TIME_TYPE),
            ID: id,
            INW_COUNT: Number(row.PRODUCT_COUNT),
            ORDER_DETAIL_ID: Number(this.addlist_row.ORDER_DETAIL_ID),
            LACK_COUNT: row.NEED_COUNT, // 出库数量
            WAREHOUSE_PRODUCT_NAME: row.PRODUCT_NAME,
            NEW_TYPE_UNIT: row.TYPE_UNIT,
            PLACE_LACK_COUNT: 0,
            PRODUCTION_DATE: row.PRODUCTION_DATE,
            WAREHOUSE_PRODUCT_CODE: row.PRODUCT_CODE,
            PRODUCT_PRICE: row.PRODUCT_PRICE,
            TYPE_UNIT: this.addlist_row.TYPE_UNIT,
            NAME: this.addlist_row.NAME,
            NEED_COUNT: this.addlist_row.NEED_COUNT, // 所需总量
          },
        ];
        for (let i = 0; i < this.listData.length; i++) {
          if (data[0].BATCH === this.listData[i].BATCH) {
            if (data[0].ID === this.listData[i].ID) {
              this.listData[i].LACK_COUNT = Number(this.listData[i].LACK_COUNT) + Number(data[0].LACK_COUNT);
              tag = false;
            }
          }
        }
        if (tag) {
          this.listData.splice(this.rowIndex, 0, data[0]);
        }
        this.spanArr = [];
        this.rowspan();
      }
    },
    submitLaunchToDelivery() {
      let text = '';
      const pass = this.listData.every((item) => {
        text = this.checkDeliveryCountFailed(item);
        return !text;
      });
      if (!pass) {
        this.$message.show({ text, type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10177',
        OTYPE: 35,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        DATA_LIST: [{
          ORDER_ID: Number(sessionStorage.getItem('orderId')),
          PRODUCT_ARRAY: this.listData.map((item) => ({ ...item, DELIVER_COUNT: item.LACK_COUNT })).filter(({ DELIVER_COUNT }) => DELIVER_COUNT != 0),
        }],
        WAREHOUSE_MODE: Number(sessionStorage.getItem('WAREHOUSE_MODE')),
      };
      http.post(params).then((res) => {
        let errorList = [];
        if (res[0]) {
          this.outOfStockList = res[0].STOCK_OUT_LIST || [];
          errorList = res[0].ERROR_LIST || [];
        }
        if (errorList.length) {
          this.$message.show({ text: errorList[0].REASON, type: 'warning' });
        } else {
          this.$message.show({ text: '发起成功', type: 'success' });
          this.deliveryDialog = false;
        }
        if (this.outOfStockList.length) {
          this.outOfStockForm.SEND_DATE = this.outOfStockList[0].SEND_DATE;
          this.outOfStockDialog = true;
        } else {
          setTimeout(() => {
            this.$router.push({ name: 'entryOrderList' });
          }, 100);
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // -------------------------------拉取供应商信息
    queryCustomer() {
      const params = {};
      if (this.addForm.customer) {
        params.SUPPLIER_NAME = this.addForm.customer;
      }
      haveGYSFun().then((result) => {
        if (result.length !== 0) {
          this.companys = result[0].list;
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitPurchase() {
      showFullScreenLoading();

      const text = [];
      const pass = this.outOfStockList.every((item) => {
        if (this.checkPurchaseCountFailed(item)) {
          text.push(this.checkPurchaseCountFailed(item));
        }
        if (this.checkPurchasePriceFailed(item)) {
          text.push(this.checkPurchasePriceFailed(item));
        }
        if (!item.SUPPLIER_ID) {
          text.push('必须选择供应商');
        }
        return !text.length;
      });

      if (!pass) {
        this.$message.show({ text: text.join(','), type: 'warning' });
        tryHideFullScreenLoading();
        return;
      }
      const tmpObj = {};
      for (const detail of this.outOfStockList) {
        if (Number(detail.PURCHASE_COUNT)) {
          if (tmpObj[`${detail.SUPPLIER_ID}`]) {
            tmpObj[`${detail.SUPPLIER_ID}`].LIST.push(detail);
          } else {
            tmpObj[`${detail.SUPPLIER_ID}`] = {
              SEND_DATE: this.outOfStockForm.SEND_DATE,
              SUPPLIER_ID: detail.SUPPLIER_ID,
              LIST: [detail],
            };
          }
        }
      }
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 56,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_LIST: Object.values(tmpObj),
      };
      http.post(params).then((res) => {
        if (res[0] && res[0].ERROR_LIST) {
          let warningText = '以下订单生成失败:';
          for (const { SUPPLIER_DATE, REASON } of res[0].ERROR_LIST) {
            warningText += `供应商:${SUPPLIER_DATE.split('+')[0]},日期:${SUPPLIER_DATE.split('+')[1]},${REASON};`;
          }
          this.$message.show({ text: warningText.substring(0, warningText.length - 1), type: 'warning' });
        } else {
          this.$message.show({ text: '采购单生成成功', type: 'success' });
        }
        this.deliveryDialog = false;
        this.outOfStockDialog = false;
        setTimeout(() => {
          this.$router.push({ name: 'entryOrderList' });
        }, 100);
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      }).finally(() => {
        tryHideFullScreenLoading();
      });
    },
    checkDeliveryCountFailed({ LACK_COUNT, INW_COUNT, NEW_TYPE_UNIT }) {
      if (LACK_COUNT > INW_COUNT) {
        return '出库数量不能大于库存数量';
      }
      if (util.JudgmentUnit(NEW_TYPE_UNIT)) {
        if (!validation.数量正数0验证(LACK_COUNT)) {
          return '出库数量必须为正数';
        }
      } else {
        if (!validation.数量整数正数0验证(LACK_COUNT)) {
          return '出库数量必须为正整数';
        }
      }
      return '';
    },
    closeOutOfStockDialog() {
      this.outOfStockDialog = false;
      setTimeout(() => {
        this.$router.push({ name: 'entryOrderList' });
      }, 100);
    },
    checkPurchaseCountFailed({ PURCHASE_COUNT, TYPE_UNIT }) {
      if (util.JudgmentUnit(TYPE_UNIT)) {
        if (!validation.数量正数0验证(PURCHASE_COUNT)) {
          return '采购数量必须为正数';
        }
      } else {
        if (!validation.数量整数正数0验证(PURCHASE_COUNT)) {
          return '采购数量必须为正整数';
        }
      }
      return '';
    },
    checkPurchasePriceFailed({ PRICE }) {
      if (!validation.价格正数0验证(PRICE)) {
        return '单价必须为非负数';
      }
      return '';
    },
    onDeliveryBlur({ LACK_COUNT, INW_COUNT, NEW_TYPE_UNIT }) {
      const text = this.checkDeliveryCountFailed({ LACK_COUNT, INW_COUNT, NEW_TYPE_UNIT });
      if (text) {
        this.$message.show({ text, type: 'warning' });
      }
    },
    onPurchaseCountBlur({ PURCHASE_COUNT, TYPE_UNIT }) {
      const text = this.checkPurchaseCountFailed({ PURCHASE_COUNT, TYPE_UNIT });
      if (text) {
        this.$message.show({ text, type: 'warning' });
      }
    },
    onPurchasePriceBlur({ PRICE }) {
      const text = this.checkPurchasePriceFailed({ PRICE });
      if (text) {
        this.$message.show({ text, type: 'warning' });
      }
    },
    getTableRowClass({ row, rowIndex }) {
      if (!row.PRODUCT_CODE) {
        return 'product_error_row';
      }
      return '';
    },
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从录入订单进入手动录入', type: 'warning' });
        that.$router.go(-1);
      } else {
        // 控制是否可以自行修改价格
        if (Number(that.CAN_MODIFY_PRICE) === 1) {
          that.isisdisabled = false;
        } else {
          that.isisdisabled = true;
        }
        that.queryTable();
        that.queryUnit();
        that.queryBeforeFun();
        that.queryCustomer();
      }
    });
  },
};
</script>
<style scoped>
.inline-input {
  width: 500px;
}

.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 30px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

li span {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}

p span {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}

.el-table >>> .product_error_row {
  background-color: rgb(255, 200, 200);
  /* color: #fff; */
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/addOrder.vue